import $ from 'jquery';

//fires defined event after collapse toggle hide the element

export default function () {
    $(document).on('hidden.bs.collapse', 'div', function () {
   // $('[data-fire-on-hide]').on('hidden.bs.collapse', function () {
        const eventName = $(this).data("fire-on-hide");
        window.dispatchEvent(new Event(eventName));
    })


}



// WEBPACK FOOTER //
// ./App/config/fire-on-hide.js